import UtmTracker from 'utils/utm_tracker'
import GclidFlag from 'utils/gclid_flag'
import OrganicFlag from 'utils/organic_flag'

class LeadMedium {
  static getName () {
    const hasGclid = GclidFlag.isPresent()
    if (hasGclid) {
      return 'google_ads'
    }

    const utmMedium = UtmTracker.getUtmMedium()
    if (utmMedium) {
      return utmMedium
    }

    const isOrganic = OrganicFlag.isOrganic()
    if (isOrganic) {
      return 'organic'
    }

    return 'direct'
  }
}

export default LeadMedium
